import { render, staticRenderFns } from "./PopoverMenuContainer.vue?vue&type=template&id=67b70998&scoped=true&"
import script from "./PopoverMenuContainer.vue?vue&type=script&lang=js&"
export * from "./PopoverMenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./PopoverMenuContainer.vue?vue&type=style&index=0&id=67b70998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b70998",
  null
  
)

export default component.exports